"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";

const PrivacyPolicySection: React.FC<
  SectionProps<{ contentTextColor: string, headerTextColor: string }>
> = ({ cmsSection }) => {
  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "xl",
      })}
    >
      <div className="flex h-full flex-col w-full items-center justify-center homepage-p-md homepage-gap-lg">
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-md homepage-p-none">Indledning</div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="homepage-text-sm homepage-p-none">
            <div>
              <p>Vi er en virksomhed, der tilbyder dig vores ydelser og løsninger. For at kunne levere en optimal service registrerer og behandler vi dine personoplysninger i overensstemmelse med gældende databeskyttelseslovgivning. Denne politik forklarer, hvordan vi håndterer dine oplysninger, og hvilke rettigheder du har.</p>
            </div>
          </div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-md homepage-p-none">Hvorfor behandler vi dine personoplysninger?</div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-sm homepage-p-none">
            <div>
              <p>Vi registrerer og anvender dine personoplysninger, når:</p>
              <ul>
                <li>du opretter en konto eller kontakter os</li>
                <li>du anmoder om information eller bestiller en ydelse</li>
                <li>det er nødvendigt for at opfylde en aftale med dig</li>
                <li>det kræves for at overholde lovgivningen, fx. regnskabs- og sikkerhedskrav</li>
                <li>det er nødvendigt for at forfølge vores legitime interesser, eksempelvis ved forbedring af vores service og forebyggelse af svindel</li>
              </ul>
              <p>Vi behandler kun dine oplysninger i det omfang, det er nødvendigt.</p>
            </div>
          </div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-md homepage-p-none">Følsomme oplysninger</div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-sm homepage-p-none">
            <div>
              <p>Vi registrerer kun følsomme personoplysninger, når det er strengt nødvendigt for at levere specifikke ydelser eller opfylde lovkrav. Inden vi behandler sådanne data, indhenter vi altid dit udtrykkelige samtykke.</p>
            </div>
          </div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-md homepage-p-none">Hvornår og hvordan registrerer og bruger vi dine personoplysninger?</div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-sm homepage-p-none">
            <div>
              <p>Vi behandler dine oplysninger i forbindelse med:</p>
              <ul>
                <li>oprettelse og vedligeholdelse af din konto</li>
                <li>behandling af dine henvendelser, bestillinger og aftaler</li>
                <li>kundeservice, rådgivning og administration</li>
                <li>markedsføring af vores ydelser (når du har givet samtykke)</li>
                <li>overholdelse af lovkrav</li>
              </ul>
              <p>Oplysningerne opbevares kun så længe, de er nødvendige for de formål, de er indsamlet til.</p>
            </div>
          </div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-md homepage-p-none">Personoplysninger fra tredjepart</div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-sm homepage-p-none">
            <div>
              <p>Vi kan modtage oplysninger om dig fra tredjepart, eksempelvis fra offentligt tilgængelige registre eller samarbejdspartnere, hvis det er nødvendigt for at levere vores ydelser eller opfylde lovkrav.</p>
            </div>
          </div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-md homepage-p-none">Tredjeparter, som vi deler dine personoplysninger med</div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-sm homepage-p-none">
            <div>
              <p>Vi kan dele dine personoplysninger med følgende tredjeparter:</p>
              <ul>
                <li>Serviceudbydere til it-drift, hosting, kundesupport og administration</li>
                <li>Samarbejdspartnere og underleverandører, der hjælper med levering af vores ydelser</li>
                <li>Offentlige myndigheder, når lovgivningen kræver det</li>
                <li>Internt i koncernen for at sikre en effektiv service</li>
              </ul>
              <p>Vi sikrer, at alle tredjeparter overholder gældende databeskyttelseslovgivning.</p>
            </div>
          </div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-md homepage-p-none">Dine rettigheder</div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-sm homepage-p-none">
            <div>
              <p>Du har ret til at:</p>
              <ul>
                <li>Få indsigt i de oplysninger, vi har om dig</li>
                <li>Få rettet forkerte eller ufuldstændige oplysninger</li>
                <li>Få slettet dine data, når der ikke foreligger et lovligt grundlag for fortsat behandling</li>
                <li>Gøre indsigelse mod behandlingen af dine oplysninger, eksempelvis til direkte markedsføring</li>
                <li>Modtage dine oplysninger i et elektronisk maskinlæsbart format (dataportabilitet)</li>
                <li>Trække dit samtykke tilbage, hvis behandlingen er baseret herpå</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-md homepage-p-none">Kontaktoplysninger og klageadgang</div>
        </div>
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-sm homepage-p-none">
            <div>
              <p>Hvis du har spørgsmål om denne privatlivspolitik eller ønsker at udøve dine rettigheder, er du velkommen til at kontakte os.</p>
              <p>Skulle du mene, at vi behandler dine personoplysninger i strid med gældende lov, kan du indgive en klage til Datatilsynet: Datatilsynet, Borgergade 28, 5., DK-1300 København K, e-mail: dt@datatilsynet.dk</p>
            </div>
          </div>
        </div>
      </div>

    </SectionLayout>
  );
};

export default PrivacyPolicySection;
